import { ApplicationSanitized } from '@backend/sanitize/application'

/**
 * Gets the fee amount to display to the user.
 * Prioritizes the evaluated (payable) amount, falling back to the original amount.
 */
export function getApplicationFeeAmount(application: ApplicationSanitized | null): number {
  return (
    application?.attributes?.applicationFee?.payableFee ??
    application?.attributes?.applicationFee?.amount ??
    0
  )
}

/**
 * Determines whether the application currently has a fee payable.
 */
export function hasApplicationFee(application: ApplicationSanitized | null): boolean {
  return getApplicationFeeAmount(application) > 0
}
